import PropTypes from 'prop-types';
import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import virtualizedMenuRenderer from 'UIComponents/input/utils/virtualizedMenuRenderer';

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime";
function SingleFilterSelect(props) {
  return /*#__PURE__*/_jsx(UIFormControl, {
    "data-test-id": "filter-select-label",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: props.labelLangPath
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      "data-test-id": "filter-select-internal",
      defaultValue: props.defaultValue,
      menuRenderer: virtualizedMenuRenderer,
      onChange: ({
        target: {
          value
        }
      }) => props.onSelect(value),
      options: props.options,
      placeholder: props.placeholderLangPath ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: props.placeholderLangPath
      }) : undefined
    })
  });
}
SingleFilterSelect.propTypes = {
  defaultValue: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  labelLangPath: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  placeholderLangPath: PropTypes.string
};
SingleFilterSelect.defaultProps = {
  defaultValue: null,
  placeholderLangPath: ''
};
export default /*#__PURE__*/memo(SingleFilterSelect);